import React from 'react'
import _ from 'lodash'
import './3d-login.css'
import MenuBar from './MenuBar';
import NavBar from './NavBar';
import { withRouter } from 'react-router-dom'
import { Button, Message, Loader, Dimmer } from 'semantic-ui-react'
import { deviceDetails } from '../Common/DeviceDetect'
import { Balerion } from '../BlueMoon'
import ProductGrid from './ProductGrid'
import { Dimple } from '../BlueMoon'
import { getTheme } from '../../config/clientConfig'

import axios from 'axios'

class Login extends React.Component {

	constructor(props) {
		super(props);
		this.state = { userName: '', userPassword: '', error: false, ip: '' };
	}

	setField = (fieldName, event) => {
		this.setState({ [fieldName]: event.target.value })
	}

	callBackFunc = () => {
		this.setState({ userName: '', userPassword: '' });
	}

	componentDidMount = () => {

		axios.get(`https://api.ipify.org?format=json`).then((response) => {
			this.setState({ ip: response.data.ip });
		}, "json");
	}

	componentWillReceiveProps = () => {
		this.setState({ error: false })
	}

	checkUserExist = (userName, userPassword) => {
		this.setState({loader: true}, () => {

			axios({
				method: 'post',
				url: `${Balerion}token/generate-token`,
				headers: {},
				data: { "username": userName, "password": userPassword, "productName": "sponsorintel", "deviceName": deviceDetails.deviceName, "ip": this.state.ip, "osName": deviceDetails.osName, "browserVersion": deviceDetails.browserVersion }
			}).then((response) => {
				if (response.data.message === "success") {
					this.setState({ loader: false }, () => {
						localStorage.setItem('user', response.data.result.username);
						localStorage.setItem('token', response.data.result.token);
						localStorage.setItem('userId', response.data.result.userId);
						localStorage.setItem('userRole', response.data.result.role);
						this.props.history.push('home')
						// this.setState({"flag": "true"})
						// this.props.onLogin(true);
					});
	
				} else {
					this.setState({
						loader: false,
						error: true
					})
				}
			}).catch((err) => {
				this.setState({
					loader: false,
					error: true
				})
			});
		})
		
	}

	render() {
		const theme = getTheme();
		var currentUrl = document.URL;
		var isHome = (currentUrl.split("/#/")[1] === "home") ? true: false;
		console.log(isHome)
		if(isHome)
			return <MenuBar tempFunc={this.callBackFunc} />
		
		if (!_.isEmpty(localStorage.getItem('projectIp'))) return (
			
			<div>
			<MenuBar tempFunc={this.callBackFunc} />
			<NavBar/>
			</div>
		);

		if (!_.isEmpty(localStorage.getItem('user'))) 
			return <MenuBar tempFunc={this.callBackFunc} />
		

		
		return (
			<div style={{width: this.state.flag ? "0" : "100%"}}>
								 <Dimmer active = {this.state.loader}>
        <Loader indeterminate>verifying credentials ...</Loader>
      </Dimmer>

			<div className={"limiter"} style={{
				backgroundColor: theme.backgrounds.loginPage,
			}}>
				<div className={"container-login100"} >
					<div className="wrap-login100" style={{ marginBottom: '10rem', backgroundColor: theme.forms.loginFormBackground, opacity: theme.forms.loginFormOpacity }}>
						<form className="login100-form validate-form" style={{display: "flex", flexDirection: "column"}}>
							<div style={{display: "flex", alignItems: "center", padding: "10px 10px 50px", gap: "12px"}}>
								<img style={{height: theme.logos.secondaryHeight}} src={theme.logos.secondary} />
								<img style={{height: theme.logos.primaryHeight}} src={theme.logos.primary}/>
							</div>

							<div className="wrap-input100 validate-input" data-validate="Enter username" style={{ color: theme.text.primary }}>
								<input className="input100" type="text" name="username" placeholder="Username" value={this.state.userName} onChange={this.setField.bind(this, "userName")} style={{ color: theme.text.primary }} />
								<span className="focus-input100" data-placeholder="&#xf207;"></span>
							</div>

							<div className="wrap-input100 validate-input" data-validate="Enter password">
								<input className="input100" type="password" name="pass" placeholder="Password" value={this.state.userPassword} onChange={this.setField.bind(this, "userPassword")} style={{ color: theme.text.primary }} />
								<span className="focus-input100" data-placeholder="&#xf191;"></span>
							</div>

							<div className="contact100-form-checkbox">
								<input className="input-checkbox100" id="ckb1" type="checkbox" name="remember-me" />
								<label className="label-checkbox100" for="ckb1">
									Remember me
						</label>
							</div>

							<Button circular size={'large'} style={{ backgroundColor: theme.buttons.primary }} onClick={(e) => {
							this.checkUserExist(this.state.userName, this.state.userPassword)
							e.preventDefault();
						}}>
							Login
						</Button>
						</form>
						
						<Message negative style={{ visibility: (this.state.error) ? 'visible' : 'hidden' }}>
							<Message.Header>Wrong username or password</Message.Header>
						</Message>
					</div>
				</div>

			</div>

			</div>


		)
	}
}

export default withRouter(Login);